// 임시 사용자 데이터
export const users = [
  {
    _id: 'user1',
    name: '김학생',
    email: 'student@example.com',
    role: 'student',
    enrolledCourses: ['course1', 'course2'],
    createdAt: '2023-01-15T00:00:00Z'
  },
  {
    _id: 'user2',
    name: '이관리자',
    email: 'admin@example.com',
    role: 'admin',
    enrolledCourses: [],
    createdAt: '2022-12-10T00:00:00Z'
  }
];

// 임시 강의 데이터
export const courses = [
  {
    _id: 'course1',
    title: '수학 1A 개념',
    description: '일본 대학 입시에 필요한 수학 1A 핵심 개념을 체계적으로 학습합니다. 방정식, 부등식, 함수, 삼각함수 등 기초부터 심화 내용까지 다룹니다. 실제 일본 대학 기출문제와 유사한 문제들을 통해 실전 감각을 키울 수 있습니다.',
    price: 320000,
    instructor: {
      name: '박민준',
      bio: '삿포로의과대학 의학과, 세종과고 출신, 홋카이도 대학 정보이공학 전공',
      avatar: 'https://via.placeholder.com/100x100?text=박민준'
    },
    thumbnail: 'https://via.placeholder.com/800x450?text=수학+1A+개념',
    category: 'EJU',
    level: '기초-중급',
    duration: '10주',
    isPublished: true,
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-01-15T00:00:00Z'
  },
  {
    _id: 'course2',
    title: '수학 2B 개념',
    description: '일본 대학 입시 수학 2B 과정으로 미적분, 수열, 벡터, 확률과 통계 등 핵심 개념을 학습합니다. 다양한 문제 풀이와 해설을 제공하며, 일본 대학별 기출문제 분석을 통해 실전 대비 능력을 향상시킵니다.',
    price: 350000,
    instructor: {
      name: '박민준',
      bio: '삿포로의과대학 의학과, 세종과고 출신, 홋카이도 대학 정보이공학 전공',
      avatar: 'https://via.placeholder.com/100x100?text=박민준'
    },
    thumbnail: 'https://via.placeholder.com/800x450?text=수학+2B+개념',
    category: 'EJU',
    level: '중급-고급',
    duration: '12주',
    isPublished: true,
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-01-15T00:00:00Z'
  },
  {
    _id: 'course3',
    title: '물리 개념',
    description: '일본 대학 입시 물리 과목의 핵심 개념을 다루는 강의입니다. 역학, 전자기학, 열역학, 파동, 현대물리 등 주요 내용을 학습하며, 실험 영상과 함께 개념을 이해하고 문제 풀이 능력을 향상시킵니다.',
    price: 380000,
    instructor: {
      name: '박민준',
      bio: '삿포로의과대학 의학과, 세종과고 출신, 홋카이도 대학 정보이공학 전공',
      avatar: 'https://via.placeholder.com/100x100?text=박민준'
    },
    thumbnail: 'https://via.placeholder.com/800x450?text=물리+개념',
    category: 'EJU',
    level: '중급',
    duration: '14주',
    isPublished: true,
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-01-15T00:00:00Z'
  }
];

// 임시 강의 레슨 데이터
export const lessons = [
  {
    _id: 'lesson1',
    courseId: 'course1',
    title: '1강: 수학 1A 개요 및 방정식 기초',
    description: '수학 1A 과정의 전체적인 개요와 방정식의 기본 개념을 학습합니다.',
    duration: '50분',
    videoUrl: 'https://example.com/videos/math1a-lesson1.mp4',
    isFree: true,
    order: 1
  },
  {
    _id: 'lesson2',
    courseId: 'course1',
    title: '2강: 이차방정식과 이차함수',
    description: '이차방정식의 해법과 이차함수의 그래프, 최대최소 문제를 다룹니다.',
    duration: '55분',
    videoUrl: 'https://example.com/videos/math1a-lesson2.mp4',
    isFree: false,
    order: 2
  },
  {
    _id: 'lesson3',
    courseId: 'course2',
    title: '1강: 수학 2B 개요 및 미분의 기초',
    description: '수학 2B 과정의 개요와 미분의 기본 개념, 도함수의 의미를 학습합니다.',
    duration: '50분',
    videoUrl: 'https://example.com/videos/math2b-lesson1.mp4',
    isFree: true,
    order: 1
  },
  {
    _id: 'lesson4',
    courseId: 'course2',
    title: '2강: 미분법과 도함수의 활용',
    description: '다양한 함수의 미분법과 도함수를 활용한 문제 풀이를 학습합니다.',
    duration: '60분',
    videoUrl: 'https://example.com/videos/math2b-lesson2.mp4',
    isFree: false,
    order: 2
  },
  {
    _id: 'lesson5',
    courseId: 'course3',
    title: '1강: 물리학 개요 및 역학의 기초',
    description: '물리학의 기본 개념과 역학의 기초, 운동의 법칙을 학습합니다.',
    duration: '50분',
    videoUrl: 'https://example.com/videos/physics-lesson1.mp4',
    isFree: true,
    order: 1
  },
  {
    _id: 'lesson6',
    courseId: 'course3',
    title: '2강: 운동량과 에너지',
    description: '운동량 보존 법칙과 에너지 보존 법칙, 충돌 문제를 다룹니다.',
    duration: '55분',
    videoUrl: 'https://example.com/videos/physics-lesson2.mp4',
    isFree: false,
    order: 2
  }
]; 